import React from 'react';
import ServiceCollection from '../ServiceCollection';
import { MultidimensionalAllocationState } from './MultidimensionalAllocationState';
import TPEAction from "src/models/common/TPEAction";

export interface MultidimensionalAllocationContextType {
    services: ServiceCollection;
    multidimensionalAllocationState: MultidimensionalAllocationState;
    multidimensionalAllocationDispatch: React.Dispatch<TPEAction>;
}

export const MultidimensionalAllocationContext = React.createContext<MultidimensionalAllocationContextType>({} as MultidimensionalAllocationContextType);
